module.exports = __webpack_public_path__ + "img/upgrade5.ecbe9eb0.png";